import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@/app/core/enums/PermissionEnum";

export const routePrivateProfile: Array<RouteRecordRaw> = [
  {
    path: "profile",
    name: "ProfileLayout",
    component: () => import("@/app/private/pages/profile/ProfileLayout.vue"),
    meta: {
      requireAuth: true,
      permissions: [PermissionEnum.MasterAccount, PermissionEnum.OrdersViewAssigned],
    },
    children: [
      {
        path: "",
        name: "Profile",
        component: () => import("@/app/private/pages/profile/pages/my-profile/MyProfile.vue"),
      },
      {
        path: "users",
        name: "MyUsers",
        component: () => import("@/app/private/pages/profile/pages/my-users/MyUsers.vue"),
        meta: {
          permissions: [PermissionEnum.AccountManage],
        },
      },
      {
        path: "notifications",
        name: "Notifications",
        component: () =>
          import("@/app/private/pages/profile/pages/notifications/Notifications.vue"),
      },
      {
        path: "saved-equipment",
        name: "SavedEquipment",
        component: () =>
          import("@/app/private/pages/profile/pages/saved-equipment/SavedEquipment.vue"),
        meta: {
          permissions: [PermissionEnum.OrdersManageEquipment],
        },
      },
      {
        path: "payment-methods",
        name: "PaymentMethods",
        component: () =>
          import("@/app/private/pages/profile/pages/payment-methods/PaymentMethods.vue"),
        meta: {
          permissions: [PermissionEnum.AccountManage],
        },
      },
      {
        path: "notification-settings",
        name: "NotificationSettings",
        component: () =>
          import("@/app/private/pages/profile/pages/notification-settings/NotificationSettings.vue"),
      },
      {
        path: "saved-contacts",
        name: "SavedContacts",
        component: () =>
          import("@/app/private/pages/profile/pages/saved-contacts/SavedContacts.vue"),
        meta: {
          permissions: [PermissionEnum.OrdersManageEquipment],
        },
      },
    ],
  },
];
